import React from 'react';
import { motion } from 'framer-motion';
import { useNavigation } from '../NavigationContext';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

  .ar-page * { box-sizing: border-box; margin: 0; padding: 0; }
  .ar-page { font-family: 'Inter', sans-serif; color: #0c1a36; background: #ffffff; width: 100%; }

  .ar-breadcrumb { max-width: 1200px; margin: 0 auto; padding: 24px 24px 0; display: flex; align-items: center; gap: 8px; font-size: 13px; color: #94a3b8; }
  .ar-breadcrumb-btn { background: none; border: none; cursor: pointer; color: #1e4d8c; font-size: 13px; font-weight: 600; padding: 0; display: inline-flex; align-items: center; gap: 5px; transition: color 0.2s; }
  .ar-breadcrumb-btn:hover { color: #c9931a; }

  /* ── Hero ── */
  .ar-hero { position: relative; padding: 60px 24px 100px; overflow: hidden; background: #fff; }
  .ar-hero-blob1 { position: absolute; top: -8%; right: -4%; width: 540px; height: 540px; border-radius: 50%; background: radial-gradient(circle, rgba(220,38,38,0.12), rgba(201,147,26,0.1)); filter: blur(80px); pointer-events: none; }
  .ar-hero-blob2 { position: absolute; bottom: -12%; left: -6%; width: 580px; height: 580px; border-radius: 50%; background: radial-gradient(circle, rgba(12,26,54,0.18), rgba(30,77,140,0.1)); filter: blur(80px); pointer-events: none; }
  .ar-hero-inner { max-width: 1200px; margin: 0 auto; display: grid; grid-template-columns: 1fr 1fr; gap: 72px; align-items: center; position: relative; z-index: 1; }
  @media (max-width: 900px) { .ar-hero-inner { grid-template-columns: 1fr; } .ar-hero-right { display: none; } }

  .ar-badge { display: inline-flex; align-items: center; gap: 8px; padding: 8px 18px; border-radius: 999px; background: #fef3c7; border: 1px solid #fde68a; font-size: 12.5px; font-weight: 600; color: #92400e; margin-bottom: 28px; }
  .ar-hero h1 { font-size: clamp(1.725rem, 3.375vw, 2.85rem); font-weight: 900; line-height: 1.1; letter-spacing: -0.03em; color: #0c1a36; margin-bottom: 22px; }
  .ar-gradient { background: linear-gradient(135deg, #dc2626 0%, #c9931a 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
  .ar-hero-sub { font-size: 1.1rem; color: #475569; line-height: 1.82; margin-bottom: 36px; max-width: 520px; }
  .ar-btn-group { display: flex; gap: 14px; flex-wrap: wrap; }
  .ar-btn-primary { padding: 14px 28px; background: #0c1a36; color: #fff; border: none; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: background 0.2s, transform 0.15s; }
  .ar-btn-primary:hover { background: #1e4d8c; transform: translateY(-1px); }
  .ar-btn-secondary { padding: 14px 28px; background: #fff; color: #334155; border: 1px solid #e2e8f0; border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .ar-btn-secondary:hover { border-color: #fde68a; background: #fffbeb; color: #92400e; }

  /* Hero right — expiry countdown card */
  .ar-hero-right { display: flex; flex-direction: column; gap: 16px; }
  .ar-expiry-card { background: #0c1a36; border-radius: 22px; padding: 32px; position: relative; overflow: hidden; box-shadow: 0 24px 64px rgba(12,26,54,0.3); }
  .ar-expiry-dots { position: absolute; inset: 0; opacity: 0.07; background-image: radial-gradient(circle, rgba(255,255,255,0.9) 1px, transparent 0); background-size: 20px 20px; pointer-events: none; }
  .ar-expiry-label { font-size: 11px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: rgba(255,255,255,0.4); margin-bottom: 14px; }
  .ar-expiry-company { font-size: 14px; font-weight: 700; color: rgba(255,255,255,0.8); margin-bottom: 6px; }
  .ar-expiry-date { font-size: 28px; font-weight: 900; color: #f87171; margin-bottom: 4px; }
  .ar-expiry-status { font-size: 12px; color: rgba(255,255,255,0.5); margin-bottom: 20px; }
  .ar-expiry-alert { background: rgba(220,38,38,0.15); border: 1px solid rgba(220,38,38,0.3); border-radius: 12px; padding: 14px 16px; font-size: 12.5px; color: #fca5a5; line-height: 1.5; margin-bottom: 16px; }
  .ar-expiry-divider { height: 1px; background: rgba(255,255,255,0.08); margin: 4px 0 16px; }
  .ar-expiry-managed { background: rgba(16,185,129,0.12); border: 1px solid rgba(16,185,129,0.25); border-radius: 12px; padding: 14px 16px; display: flex; align-items: center; gap: 10px; }
  .ar-expiry-managed-icon { font-size: 20px; }
  .ar-expiry-managed-text { font-size: 12.5px; color: #6ee7b7; line-height: 1.5; }
  .ar-reminder-card { background: #fff; border-radius: 16px; padding: 18px 22px; box-shadow: 0 4px 16px rgba(12,26,54,0.1); display: flex; align-items: center; gap: 14px; }
  .ar-reminder-icon { width: 40px; height: 40px; border-radius: 10px; background: #ecfdf5; display: flex; align-items: center; justify-content: center; font-size: 18px; flex-shrink: 0; }
  .ar-reminder-label { font-size: 11px; color: #94a3b8; font-weight: 500; }
  .ar-reminder-value { font-size: 14.5px; font-weight: 800; color: #0c1a36; margin-top: 2px; }

  /* ── Shared ── */
  .ar-section { padding: 88px 24px; }
  .ar-container { max-width: 1200px; margin: 0 auto; }
  .ar-section-header { text-align: center; max-width: 720px; margin: 0 auto 60px; }
  .ar-section-header h2 { font-size: clamp(1.8rem, 3.2vw, 2.7rem); font-weight: 800; color: #0c1a36; letter-spacing: -0.02em; margin-bottom: 14px; line-height: 1.2; }
  .ar-section-header p { font-size: 1.03rem; color: #64748b; line-height: 1.8; }
  .ar-kicker { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #1e4d8c; margin-bottom: 12px; }

  /* ── Consequences (dark) ── */
  .ar-cons-bg { background: #0c1a36; position: relative; overflow: hidden; }
  .ar-cons-glow { position: absolute; top: -10%; right: 15%; width: 500px; height: 500px; background: radial-gradient(circle, rgba(220,38,38,0.14), transparent 70%); pointer-events: none; }
  .ar-cons-bg .ar-kicker { color: #fca5a5; }
  .ar-cons-bg .ar-section-header h2 { color: #fff; }
  .ar-cons-bg .ar-section-header p { color: #94a3b8; }
  .ar-cons-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
  @media (max-width: 900px) { .ar-cons-grid { grid-template-columns: 1fr 1fr; } }
  @media (max-width: 580px) { .ar-cons-grid { grid-template-columns: 1fr; } }
  .ar-con-card { background: rgba(220,38,38,0.06); border: 1px solid rgba(220,38,38,0.15); border-radius: 18px; padding: 28px; transition: all 0.3s; }
  .ar-con-card:hover { border-color: rgba(220,38,38,0.3); background: rgba(220,38,38,0.1); }
  .ar-con-icon { font-size: 26px; margin-bottom: 14px; }
  .ar-con-card h4 { font-size: 0.97rem; font-weight: 700; color: #fca5a5; margin-bottom: 8px; }
  .ar-con-card p { font-size: 0.87rem; color: #94a3b8; line-height: 1.68; }

  /* ── What Renewal Involves ── */
  .ar-involves-bg { background: #f8fafc; border-top: 1px solid rgba(226,232,240,0.7); }
  .ar-involves-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 64px; align-items: start; }
  @media (max-width: 900px) { .ar-involves-layout { grid-template-columns: 1fr; } }
  .ar-involves-left h2 { font-size: clamp(1.8rem, 3vw, 2.5rem); font-weight: 800; color: #0c1a36; letter-spacing: -0.02em; line-height: 1.2; margin-bottom: 16px; }
  .ar-involves-left p { font-size: 1rem; color: #475569; line-height: 1.82; margin-bottom: 28px; }
  .ar-involves-list { display: flex; flex-direction: column; gap: 14px; }
  .ar-involves-item { display: flex; gap: 14px; padding: 16px 18px; background: #fff; border: 1px solid #e2e8f0; border-radius: 14px; align-items: flex-start; transition: all 0.2s; }
  .ar-involves-item:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.06); }
  .ar-involves-num { width: 30px; height: 30px; border-radius: 8px; background: #0c1a36; color: #fff; font-size: 12px; font-weight: 800; display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-top: 1px; }
  .ar-involves-item h5 { font-size: 0.93rem; font-weight: 700; color: #0c1a36; margin-bottom: 4px; }
  .ar-involves-item p { font-size: 0.85rem; color: #64748b; line-height: 1.62; }

  /* Our Service features */
  .ar-features-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 18px; }
  @media (max-width: 580px) { .ar-features-grid { grid-template-columns: 1fr; } }
  .ar-feat-card { background: #fff; border: 1px solid #e2e8f0; border-radius: 18px; padding: 26px; transition: all 0.3s; }
  .ar-feat-card:hover { box-shadow: 0 12px 36px rgba(0,0,0,0.07); transform: translateY(-2px); }
  .ar-feat-icon { font-size: 26px; margin-bottom: 14px; }
  .ar-feat-card h4 { font-size: 0.97rem; font-weight: 700; color: #0c1a36; margin-bottom: 8px; }
  .ar-feat-card p { font-size: 0.87rem; color: #64748b; line-height: 1.68; }

  /* ── CTA ── */
  .ar-cta-bg { background: #fff; border-top: 1px solid #f1f5f9; }
  .ar-cta-inner { background: linear-gradient(135deg, #0c1a36 0%, #1a3568 60%, #0c1a36 100%); border-radius: 28px; padding: 80px 56px; text-align: center; position: relative; overflow: hidden; max-width: 900px; margin: 0 auto; }
  @media (max-width: 640px) { .ar-cta-inner { padding: 52px 28px; border-radius: 20px; } }
  .ar-cta-glow1 { position: absolute; top: -20%; right: -5%; width: 350px; height: 350px; background: radial-gradient(circle, rgba(201,147,26,0.22), transparent 65%); pointer-events: none; }
  .ar-cta-glow2 { position: absolute; bottom: -20%; left: -5%; width: 350px; height: 350px; background: radial-gradient(circle, rgba(30,77,140,0.3), transparent 65%); pointer-events: none; }
  .ar-cta-inner h2 { font-size: clamp(1.9rem, 3.5vw, 2.8rem); font-weight: 900; color: #fff; letter-spacing: -0.03em; line-height: 1.15; margin-bottom: 16px; position: relative; z-index: 1; }
  .ar-cta-inner > p { font-size: 1.05rem; color: #94a3b8; max-width: 500px; margin: 0 auto 36px; line-height: 1.75; position: relative; z-index: 1; }
  .ar-cta-btns { display: flex; gap: 14px; justify-content: center; flex-wrap: wrap; position: relative; z-index: 1; }
  .ar-cta-primary { padding: 14px 30px; background: #c9931a; color: #fff; border: none; border-radius: 12px; font-size: 15px; font-weight: 700; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; transition: background 0.2s, transform 0.15s; box-shadow: 0 4px 18px rgba(201,147,26,0.4); }
  .ar-cta-primary:hover { background: #e0a820; transform: translateY(-1px); }
  .ar-cta-secondary { padding: 14px 30px; background: rgba(255,255,255,0.07); color: #cbd5e1; border: 1px solid rgba(255,255,255,0.15); border-radius: 12px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
  .ar-cta-secondary:hover { background: rgba(255,255,255,0.13); color: #fff; }
`;

const fadeUp = { initial: { opacity: 0, y: 28 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: '-40px' }, transition: { duration: 0.55 } };
const stagger = (i: number) => ({ ...fadeUp, transition: { duration: 0.5, delay: i * 0.09 } });

const consequences = [
  { icon: '🚫', title: 'Payments Are Blocked Immediately', desc: 'When your registration lapses, federal agencies cannot issue payments on existing contracts. Funds owed to you are held until your registration is restored.' },
  { icon: '📋', title: 'You Cannot Compete for New Awards', desc: 'Contracting officers are required to verify active SAM.gov status before making any award. A lapsed registration disqualifies you from all active solicitations.' },
  { icon: '⏳', title: 'Restoration Takes Days', desc: 'Re-activating a lapsed registration is not instant. The process requires resubmission and re-validation, which can take 3–7 business days — costing you money and opportunities.' },
  { icon: '🔗', title: 'Contract Performance Risk', desc: 'If your registration lapses mid-contract, you are in technical breach of federal acquisition requirements. Contracting officers may issue cure notices.' },
  { icon: '📉', title: 'Set-Aside Eligibility Lost', desc: 'Small business set-asides, veteran-owned preferences, and HUBZone eligibility all depend on an active, current SAM.gov registration.' },
  { icon: '🔔', title: 'No Warning From the Government', desc: 'SAM.gov does not send expiration reminders. It is entirely your responsibility to track and renew — unless you have a monitoring service in place.' },
];

const involvesSteps = [
  { title: 'Expiration Date Review', desc: 'We identify your exact renewal window — SAM.gov allows renewal up to 60 days before expiration.' },
  { title: 'Profile Data Audit', desc: 'We review all fields for accuracy, updating any information that has changed since the last registration.' },
  { title: 'Certifications Update', desc: 'We verify that all representations, certifications, and socioeconomic statuses are still accurate and current.' },
  { title: 'Resubmission & Monitoring', desc: 'We resubmit the renewal and monitor its progress through the SAM.gov validation pipeline until activation is confirmed.' },
];

const serviceFeatures = [
  { icon: '🔔', title: '90/60/30-Day Renewal Alerts', desc: 'We notify you at 90, 60, and 30 days before your expiration date — giving you ample time to prepare and avoid any lapse.' },
  { icon: '📋', title: 'Annual Profile Audit', desc: 'We review your entire SAM.gov profile for accuracy each year — updating addresses, points of contact, and financial information.' },
  { icon: '⚡', title: 'Managed Renewal Submission', desc: 'We handle the full renewal submission process on your behalf, including any required updates to certifications and representations.' },
  { icon: '✅', title: 'Activation Confirmation', desc: 'We monitor your renewal through the full validation cycle and confirm your active status before marking the renewal complete.' },
];

const AnnualRenewal: React.FC = () => {
  const { navigateTo } = useNavigation();

  return (
    <>
      <style>{styles}</style>
      <div className="ar-page">

        <div className="ar-breadcrumb">
          <button className="ar-breadcrumb-btn" onClick={() => navigateTo('')}>← SAM.gov Registration</button>
          <span>/</span>
          <span>Annual Renewal</span>
        </div>

        {/* Hero */}
        <section className="ar-hero">
          <div className="ar-hero-blob1" />
          <div className="ar-hero-blob2" />
          <div className="ar-hero-inner">
            <motion.div {...fadeUp}>
              <div className="ar-badge">🔄 Required Every 12 Months</div>
              <h1>
                Never Let Your SAM.gov Registration{' '}
                <span className="ar-gradient">Expire</span>
              </h1>
              <p className="ar-hero-sub">
                SAM.gov registrations expire exactly 365 days after activation. A lapsed
                registration stops federal payments, disqualifies you from new awards, and
                can put existing contracts at risk. We make sure it never happens.
              </p>
              <div className="ar-btn-group">
                <button className="ar-btn-primary">Manage My Renewal →</button>
                <button className="ar-btn-secondary">Check My Status</button>
              </div>
            </motion.div>

            <motion.div className="ar-hero-right" initial={{ opacity: 0, x: 36 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.65, delay: 0.2 }}>
              <div className="ar-expiry-card">
                <div className="ar-expiry-dots" />
                <div className="ar-expiry-label">Without Renewal Management</div>
                <div className="ar-expiry-company">Acme Federal Services LLC</div>
                <div className="ar-expiry-date">EXPIRED</div>
                <div className="ar-expiry-status">SAM.gov Status — Registration Lapsed</div>
                <div className="ar-expiry-alert">
                  ⚠️ Registration has lapsed. Federal payments are blocked. You are ineligible to compete for new awards until registration is restored.
                </div>
                <div className="ar-expiry-divider" />
                <div className="ar-expiry-label">With BizServe Renewal Management</div>
                <div className="ar-expiry-managed">
                  <span className="ar-expiry-managed-icon">✅</span>
                  <span className="ar-expiry-managed-text">Registration renewed automatically. Active and eligible for 365 more days. Zero disruption to contracts or payments.</span>
                </div>
              </div>
              <div className="ar-reminder-card">
                <div className="ar-reminder-icon">🔔</div>
                <div>
                  <div className="ar-reminder-label">Next Renewal Reminder</div>
                  <div className="ar-reminder-value">90 Days Before Expiration</div>
                </div>
              </div>
            </motion.div>
          </div>
        </section>

        {/* Consequences */}
        <section className="ar-section ar-cons-bg">
          <div className="ar-cons-glow" />
          <div className="ar-container">
            <motion.div className="ar-section-header" {...fadeUp}>
              <div className="ar-kicker">The Risk</div>
              <h2>What Happens When Your Registration Lapses</h2>
              <p>A lapsed SAM.gov registration is not a minor inconvenience. It has immediate, serious consequences for your federal contracting business.</p>
            </motion.div>
            <div className="ar-cons-grid">
              {consequences.map((c, i) => (
                <motion.div key={i} className="ar-con-card" {...stagger(i)}>
                  <div className="ar-con-icon">{c.icon}</div>
                  <h4>{c.title}</h4>
                  <p>{c.desc}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* What Renewal Involves + Our Service */}
        <section className="ar-section ar-involves-bg">
          <div className="ar-container">
            <div className="ar-involves-layout">
              <motion.div className="ar-involves-left" {...fadeUp}>
                <div className="ar-kicker">The Renewal Process</div>
                <h2>What SAM.gov Renewal Actually Involves</h2>
                <p>
                  Renewal is not just clicking a button. It requires a thorough review of your
                  entire profile, updating any changed information, and resubmitting representations
                  and certifications. Errors during renewal can trigger a validation failure.
                </p>
                <div className="ar-involves-list">
                  {involvesSteps.map((step, i) => (
                    <div key={i} className="ar-involves-item">
                      <div className="ar-involves-num">{String(i + 1).padStart(2, '0')}</div>
                      <div>
                        <h5>{step.title}</h5>
                        <p>{step.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </motion.div>

              <motion.div {...stagger(1)}>
                <div className="ar-kicker">Our Renewal Service</div>
                <div style={{ fontSize: 'clamp(1.5rem, 2.5vw, 2rem)', fontWeight: 800, color: '#0c1a36', letterSpacing: '-0.02em', lineHeight: 1.2, marginBottom: '16px' }}>
                  Fully Managed — No Action Required From You
                </div>
                <p style={{ fontSize: '0.97rem', color: '#475569', lineHeight: 1.78, marginBottom: '28px' }}>
                  Once enrolled in our renewal management service, we monitor your expiration date, handle the full renewal submission, and confirm your active status — all without you having to lift a finger.
                </p>
                <div className="ar-features-grid">
                  {serviceFeatures.map((f, i) => (
                    <div key={i} className="ar-feat-card">
                      <div className="ar-feat-icon">{f.icon}</div>
                      <h4>{f.title}</h4>
                      <p>{f.desc}</p>
                    </div>
                  ))}
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="ar-section ar-cta-bg">
          <div className="ar-container">
            <motion.div className="ar-cta-inner" {...fadeUp}>
              <div className="ar-cta-glow1" />
              <div className="ar-cta-glow2" />
              <h2>Never Miss a Renewal Again</h2>
              <p>Let us monitor, manage, and renew your SAM.gov registration every year — so you stay eligible, stay paid, and stay competitive.</p>
              <div className="ar-cta-btns">
                <button className="ar-cta-primary">Manage My Renewal →</button>
                <button className="ar-cta-secondary">Schedule a Free Consultation</button>
              </div>
            </motion.div>
          </div>
        </section>

      </div>
    </>
  );
};

export default AnnualRenewal;
